import React, { useState } from "react";
import { Copy, Check, Heart, Temple, Sparkles } from "lucide-react";
import Banner from "../../assets/Gpouram2.jpg";


export default function DonationPage() {
    const [copiedField, setCopiedField] = useState("");
    const [showToast, setShowToast] = useState(false);

    const bankDetails = {
        bankName: "Union Bank of India",
        accountName: "M/S Sriman Narayanaswamy Thirukovil Nirvaga Sangam",
        accountNumber: "336102010210097",
        ifscCode: "UBIN0533611",
        branch: "Vadasery",
        accountType: "Current Account"
    };

    const handleCopy = (text, field) => {
        navigator.clipboard.writeText(text);
        setCopiedField(field);
        setShowToast(true);
        setTimeout(() => {
            setCopiedField("");
            setShowToast(false);
        }, 2000);
    };

    const BankDetailRow = ({ label, value, field }) => (
        <div className="flex justify-between items-center py-4 px-4 bg-white/50 rounded-xl mb-3 border-2 border-orange-100 hover:border-orange-300 hover:bg-white/80 hover:translate-x-1 transition-all duration-300">
            <div>
                <div className="text-amber-900 text-sm font-semibold mb-1">
                    {label}
                </div>
                <div className="text-amber-950 text-lg font-bold font-mono">
                    {value}
                </div>
            </div>
            <button
                onClick={() => handleCopy(value, field)}
                className={`p-3 rounded-lg transition-all duration-300 ${copiedField === field
                    ? "bg-green-500 hover:bg-green-600"
                    : "bg-orange-600 hover:bg-orange-700"
                    } text-white`}
            >
                {copiedField === field ? (
                    <Check className="w-5 h-5" />
                ) : (
                    <Copy className="w-5 h-5" />
                )}
            </button>
        </div>
    );

    return (
        <div className="min-h-screen w-full bg-gradient-to-b from-amber-50 via-orange-50 to-orange-100">
            {/* Banner Section */}
            <div className="relative w-full h-64 sm:h-96 md:h-[450px] overflow-hidden">
                <img
                    src={Banner}
                    alt="Temple Banner"
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center",
                    }}
                />
                <div className="absolute inset-0 bg-gradient-to-b from-orange-600/30 to-orange-600/70 flex flex-col justify-center items-center">
                    <div className="animate-float mb-4">
                        <div className="text-6xl md:text-8xl">🛕</div>
                    </div>
                    <h1 className="text-4xl md:text-6xl font-bold text-white text-center font-serif drop-shadow-lg mb-3 animate-fade-in">
                        நன்கொடை
                    </h1>

                </div>
            </div>

            <div className="max-w-5xl mx-auto px-4 py-8">
                {/* Intro Text */}
                <div className="text-center mb-12 animate-fade-in-up" style={{ animationDelay: "100ms" }}>


                    <div className="flex justify-center gap-2 mt-4">
                        {[0, 1, 2].map((i) => (
                            <Heart
                                key={i}
                                className="w-6 h-6 text-red-500 fill-red-500 animate-heartbeat"
                                style={{ animationDelay: `${i * 200}ms` }}
                            />
                        ))}
                    </div>
                </div>

                {/* Donation Purpose Section */}
                <div className="mb-12 animate-fade-in-up" style={{ animationDelay: "200ms" }}>
                    <div className="bg-gradient-to-br from-orange-500 to-orange-700 rounded-3xl shadow-2xl p-8 md:p-10 text-center">
                        <div className="inline-block mb-4">
                            <Sparkles className="w-12 h-12 text-amber-200 animate-pulse" />
                        </div>

                        <div className="grid md:grid-cols-2 gap-4 text-left max-w-3xl mx-auto">
                            <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 border-2 border-white/30">
                                <div className="text-3xl mb-2">🍚</div>
                                <div className="text-white font-semibold text-lg">அன்னதானம்</div>
                                <div className="text-orange-100 text-sm mt-1">தினசரி உணவு வழங்கல்</div>
                            </div>
                            <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 border-2 border-white/30">
                                <div className="text-3xl mb-2">🪔</div>
                                <div className="text-white font-semibold text-lg">தினசரி பணிவிடைகள்</div>
                                <div className="text-orange-100 text-sm mt-1"> சிறப்பு வழிபாடுகள்</div>
                            </div>
                            <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 border-2 border-white/30">
                                <div className="text-3xl mb-2">🏛️</div>
                                <div className="text-white font-semibold text-lg">கோவில் பராமரிப்பு</div>
                                <div className="text-orange-100 text-sm mt-1">கட்டிட பராமரிப்பு மற்றும் சீரமைப்பு</div>
                            </div>
                            <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 border-2 border-white/30">
                                <div className="text-3xl mb-2">💐</div>
                                <div className="text-white font-semibold text-lg">சிறப்பு விழாக்கள்</div>
                                <div className="text-orange-100 text-sm mt-1">திருவிழாக்கள்</div>
                            </div>
                        </div>

                    </div>
                </div>

                {/* Bank Details Card */}
                <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-3xl border-4 border-orange-300 shadow-2xl overflow-hidden relative animate-fade-in-up animate-glow" style={{ animationDelay: "400ms" }}>
                    <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer pointer-events-none"></div>

                    <div className="p-6 md:p-10 relative z-10">
                        {/* Header */}
                        <div className="flex items-center justify-center gap-3 mb-8 flex-wrap">
                            <div className="w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center animate-pulse">
                                <span className="text-2xl">🏦</span>
                            </div>
                            <h2 className="text-3xl md:text-4xl font-bold text-amber-900 font-serif">
                                வங்கி கணக்கு விவரங்கள்
                            </h2>
                        </div>

                        {/* Bank Details */}
                        <div className="max-w-3xl mx-auto">
                            <BankDetailRow
                                label="வங்கி பெயர் / Bank Name"
                                value={bankDetails.bankName}
                                field="bankName"
                            />
                            <BankDetailRow
                                label="கணக்கு பெயர் / Account Name"
                                value={bankDetails.accountName}
                                field="accountName"
                            />
                            <BankDetailRow
                                label="கணக்கு எண் / Account Number"
                                value={bankDetails.accountNumber}
                                field="accountNumber"
                            />
                            <BankDetailRow
                                label="IFSC குறியீடு / IFSC Code"
                                value={bankDetails.ifscCode}
                                field="ifscCode"
                            />
                            <BankDetailRow
                                label="கிளை / Branch"
                                value={bankDetails.branch}
                                field="branch"
                            />

                        </div>

                        {/* Footer Note */}
                        <div className="mt-8 p-6 bg-orange-100 rounded-2xl border-2 border-dashed border-orange-600">
                            <div className="flex items-center justify-center gap-2 mb-3">
                                <Sparkles className="w-5 h-5 text-orange-600" />
                                <h3 className="text-amber-900 font-bold text-xl font-serif">
                                    முக்கிய அறிவிப்பு
                                </h3>
                            </div>
                            <p className="text-amber-800 text-center leading-relaxed font-serif">
                                நன்கொடை செய்த பின்னர் உங்கள் பெயர், தொலைபேசி எண் மற்றும் பரிவர்த்தனை விவரங்களை
                                கோவில் அலுவலகத்திற்கு தெரிவிக்கவும்.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Blessing Message */}

            </div>

            {/* Toast Notification */}
            {showToast && (
                <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg font-semibold animate-fade-in z-50">
                    நகலெடுக்கப்பட்டது! / Copied!
                </div>
            )}

            <style>{`
                @keyframes fade-in {
                    from {
                        opacity: 0;
                    }
                    to {
                        opacity: 1;
                    }
                }

                @keyframes fade-in-up {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @keyframes float {
                    0%, 100% {
                        transform: translateY(0px);
                    }
                    50% {
                        transform: translateY(-15px);
                    }
                }

                @keyframes heartbeat {
                    0%, 100% {
                        transform: scale(1);
                    }
                    10%, 30% {
                        transform: scale(1.15);
                    }
                    20%, 40% {
                        transform: scale(1);
                    }
                }

                @keyframes shimmer {
                    0% {
                        transform: translateX(-100%);
                    }
                    100% {
                        transform: translateX(100%);
                    }
                }

                @keyframes glow {
                    0%, 100% {
                        box-shadow: 0 0 20px rgba(217,119,6,0.3);
                    }
                    50% {
                        box-shadow: 0 0 40px rgba(217,119,6,0.6);
                    }
                }

                .animate-fade-in {
                    animation: fade-in 0.8s ease-out;
                }

                .animate-fade-in-up {
                    animation: fade-in-up 0.8s ease-out;
                    animation-fill-mode: both;
                }

                .animate-float {
                    animation: float 3s ease-in-out infinite;
                }

                .animate-heartbeat {
                    animation: heartbeat 1.5s ease-in-out infinite;
                }

                .animate-shimmer {
                    animation: shimmer 3s infinite;
                }

                .animate-glow {
                    animation: glow 3s ease-in-out infinite;
                }
            `}</style>
        </div>
    );
}